// extracted by mini-css-extract-plugin
export var chevronIcon = "_si-1";
export var edgeToggle = "_si-0";